import script from "./ResponsiveImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsiveImage.vue?vue&type=script&setup=true&lang=js"

import "./ResponsiveImage.vue?vue&type=style&index=0&id=54f17afa&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54f17afa"]])

export default __exports__